import * as React from 'react';
/**
 *
 * Original name: thumbs down
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1020
 *
 */
export const ThumbsDownLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m18.988 11.416-.821-4.463A2.257 2.257 0 0 0 15.937 5H10.34c-.505 0-1.002.118-1.454.343L5 7.287V14h2.058c.317 0 .628.087.9.25l1.373.825a.745.745 0 0 1 .342.46l.992 3.965h1.09a3.249 3.249 0 0 0 3.2-3.832L14.65 14h2.1a2.26 2.26 0 0 0 2.238-2.584Zm-1.66.822a.768.768 0 0 1-.578.262h-3.9l.626 3.437A1.75 1.75 0 0 1 11.835 18l-.707-2.828a2.235 2.235 0 0 0-1.025-1.383l-1.373-.824a3.25 3.25 0 0 0-1.673-.465H6.5V8.213l3.057-1.528c.244-.122.512-.185.784-.185h5.596a.763.763 0 0 1 .75.688l.82 4.462a.733.733 0 0 1-.18.587Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
